import React from "react";
import styled, { keyframes } from "styled-components";
import { gb } from "../styles/theme";

const rock = keyframes`
  0%, 100% { transform: rotate(0deg); }
  20% { transform: rotate(-12deg); }
  50% { transform: rotate(12deg); }
  80% { transform: rotate(-6deg); }
`;

const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 16px;
`;

const Ball = styled.div`
  width: 42px;
  height: 42px;
  position: relative;
  animation: ${rock} 1.1s ease-in-out infinite;
  transform-origin: 50% 100%;
  image-rendering: pixelated;

  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 0;
    width: 100%;
    height: 50%;
    border: 3px solid ${gb.dark};
    box-sizing: border-box;
  }

  &::before {
    top: 0;
    background: #e4000f;
    border-radius: 21px 21px 0 0;
    border-bottom: 0;
  }

  &::after {
    bottom: 0;
    background: ${gb.lightest};
    border-radius: 0 0 21px 21px;
    border-top: 0;
  }
`;

const Band = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 4px;
  background: ${gb.dark};
  transform: translateY(-50%);
  z-index: 1;
`;

const Button = styled.div`
  position: absolute;
  width: 12px;
  height: 12px;
  background: ${gb.lightest};
  border: 3px solid ${gb.dark};
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;

const LoadingText = styled.div`
  font-size: 8px;
  color: ${gb.dark};
  letter-spacing: 1px;
  animation: ${blink} 1.2s steps(2, end) infinite;
`;

export const LoadingSpinner: React.FC<{ label?: string }> = ({
  label = "LOADING...",
}) => {
  return (
    <SpinnerContainer>
      <Ball>
        <Band />
        <Button />
      </Ball>
      <LoadingText>{label}</LoadingText>
    </SpinnerContainer>
  );
};
